import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Batch 34 C6 (Cowork run 32): a category page with nothing in it offers
 * a WAY ON instead of a dead end — "Browse frogs" (a secondary: the page
 * has nothing of its own to make primary) and a "Care guides" link.
 * `showBrowseFrogs` is off on /frogs itself, where it would point at the
 * page the shopper is already on.
 *
 * Imports NO stylesheet (the SchemaField rule): each host imports
 * ff-empty-state.css itself, after products.css, so no route chunk sees
 * the two in a different order.
 */
const EmptyStateWayOn = ({ showBrowseFrogs = true, className = '' }) => (
  <div className={`ff-empty-state__way-on ${className}`.trim()} data-empty-way-on>
    {showBrowseFrogs && (
      <Link to="/frogs" className="ff-btn ff-btn--secondary">
        Browse frogs
      </Link>
    )}
    <Link to="/care-guides" className="ff-empty-state__link">
      Care guides
    </Link>
  </div>
);

export default EmptyStateWayOn;
